/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.query.understanding.mkpl.autocomp.rpc.MarketplaceAutocompleteRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './MarketplaceAutocompleteRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.query.understanding.mkpl.autocomp.rpc.MarketplaceAutocompleteRpc#autocomplete
 */
export const AUTOCOMPLETE_QUERY_FIELD_NAME = 'com_hubspot_query_understanding_mkpl_autocomp_rpc_MarketplaceAutocompleteRpc_autocomplete';
export const AUTOCOMPLETE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: AUTOCOMPLETE_QUERY_FIELD_NAME,
  args: ['source', 'limit', 'language', 'fallbackLanguage', 'useSpellingCorrections', 'queryTerm'],
  fetcher(request, ctx) {
    return chirpClient.call(References.autocompleteRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});